import { useEffect, useMemo, useState } from "react";

const STORAGE_KEY = "wizardCreation:dataOffering:v1";

export function useWizardCreationDataset() {
  const [raw, setRaw] = useState(null);

  useEffect(() => {
    try {
      const txt = sessionStorage.getItem(STORAGE_KEY);
      setRaw(txt ? JSON.parse(txt) : null);
    } catch (e) {
      console.error("Invalid wizard sessionStorage JSON", e);
      setRaw(null);
    }
  }, []);

  const data = raw?.data ?? raw ?? null;

  const selectedPolicies = useMemo(() => {
    const arr = data?.step2?.selectedPolicies;
    return Array.isArray(arr) ? arr : [];
  }, [data]);

  const selectedPolicyIris = useMemo(() => {
    return selectedPolicies.map((p) => p?.id).filter(Boolean);
  }, [selectedPolicies]);

  return {
    data,
    selectedPolicies,
    selectedPolicyIris,
  };
}
